<template>
  <div class="mt-2">
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Tax Warrants' }"
        id="taxWarrants"
        class="input-text-size"
      >
      Tax Warrants
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Browse' }"
        id="browse"
        class="input-text-size"
      >
      Browse
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - TaxWarrantReports' }"
        id="taxWarrantReports"
        class="input-text-size"
      >
      Reports
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import '../../../../assets/style.css';

export default {
  name: 'PersonalTaxWarrants',
};
</script>
